import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneTeamWasChosenForEachStackValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const checkedTeamNamesOfPrimaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.NHL_TEAM_STACKING_FIRST_STACK,
        );
        const checkedTeamNamesOfSecondaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.NHL_TEAM_STACKING_SECOND_STACK,
        );
        const checkedTeamNamesOfThirdStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.NHL_TEAM_STACKING_THIRD_STACK,
        );

        if (
            !checkedTeamNamesOfPrimaryStack.length ||
            !checkedTeamNamesOfSecondaryStack.length ||
            !checkedTeamNamesOfThirdStack
        ) {
            this.addError('Should be at least one team chosen for each Stack.');
        }
    }
}

export default AtLeastOneTeamWasChosenForEachStackValidator;
